import type { ApolloClient } from "@apollo/client";
import { GET_USER } from "api/query";
import type { GetUserQuery } from "graphql/generated";

// The signed-in user, from the client's cached `GET_USER`.
export const readUser = (client: ApolloClient<object>) =>
  client.readQuery<GetUserQuery>({ query: GET_USER })?.getUser;

/**
 * Loads `GET_USER` again for the active queries. `AuthProvider` decides
 * sign-in from this answer, so call it after a session starts or ends.
 *
 * A failed load does not throw. The callers did their work before the load,
 * so they must finish it. The errorLink reports the error, and `AuthProvider`
 * keeps the last answer.
 */
export const refetchUser = async (client: ApolloClient<object>) => {
  try {
    await client.refetchQueries({ include: [GET_USER] });
  } catch (error) {
    console.error("Could not load the user again", error);
  }
};
